/**
 * This is a helper function to find an element in the DOM that is not immediately available.
 * Stencil does not offer a waitFor functionality, so this tries to find the element a few times with a delay.
 */

interface FindElementAsyncOptions<T> {
  selectorCallback: () => T | null;
  maxRetries?: number;
  delay?: number;
}

export async function findElementAsync<T>(
  options: FindElementAsyncOptions<T>
): Promise<T | null> {
  const { selectorCallback, maxRetries = 30, delay = 100 } = options;

  let retries = 0;

  while (retries < maxRetries) {
    const element = selectorCallback();
    if (element) {
      return element;
    }
    retries += 1;

    // eslint-disable-next-line no-await-in-loop
    await new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }
  return null;
}
